import * as React from 'react';

import { FromDeveloper, FinishDate, PriceInput, GeoInput, Rooms } from '../Filters';
import { MoreFiltersModal } from '../Modals/MoreFiltersModal';
import { LocationModal } from '../Modals/LocationModal';
import { QuickFiltersWrapper } from '../../components/QuickFiltersWrapper';

export const FiltersContainer: React.FC = React.memo(() => {
  return (
    <QuickFiltersWrapper>
      <MoreFiltersModal />
      <LocationModal />
      <Rooms />
      <PriceInput />
      <FinishDate />
      <FromDeveloper />
      <GeoInput />
    </QuickFiltersWrapper>
  );
});

FiltersContainer.displayName = 'FiltersContainer';
